module.exports = __webpack_public_path__ + "img/logo_boton_bancolombia.ccdf7587.png";